import React, { createContext, useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { Spinner } from 'components/common'
import { User } from 'types/user'
import { verifyToken } from 'utils/api/auth'

type Props = {
  children: React.ReactNode
}

type AuthContextType = {
  user: User
  isAuthenticated: boolean
  setIsAuthenticated: React.Dispatch<React.SetStateAction<boolean>>
}

export const AuthContext = createContext<undefined | AuthContextType>(undefined)

const AuthProvider: React.FC<Props> = ({ children }) => {
  const { pathname } = useLocation()

  const [user, setUser] = useState<User | any>({})
  const [loading, setLoading] = useState<boolean>(true)
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false)

  const fetchUser = async () => {
    try {
      const { data } = await verifyToken()
      if (data?.user && data?.user?.isActive) {
        setUser(data?.user)
        setIsAuthenticated(true)
      }
    } catch (error) {
      setUser({})
      setIsAuthenticated(false)
    }
    setLoading(false)
  }

  useEffect(() => {
    fetchUser()
  }, [pathname])

  const value: AuthContextType = useMemo(
    () => ({
      user,
      isAuthenticated,
      setIsAuthenticated,
    }),
    [user, isAuthenticated],
  )

  return (
    <AuthContext.Provider value={value}>
      {loading ? (
        <div className="flex h-screen w-full flex-col items-center justify-center">
          <Spinner size="large" />
        </div>
      ) : (
        children
      )}
    </AuthContext.Provider>
  )
}

export default AuthProvider
